import { stripeRadius } from './StripeStore';

import { stripeRadiusDefault } from './StripeStoreDefaults';

export const resetStripeRadius = () => stripeRadius.set(stripeRadiusDefault);
